import React, { useEffect, useState } from 'react';
import Sticky from 'react-stickynode';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProjects } from '~/cards/actions/draftsAndOrdersActions';
import { fetchFavoriteCardSuites } from '~/favorites/redux/actions';
import { getUserContext } from '~/selectors/user/userSelectors';
import { FilterMobileMenuV2 } from '~/cards/components/CardListing/CardListingRedesign/CardListingFilter/FilterMobileMenuV2';
import { CardListingSearchFilters, FilterKey, FilterValue } from '../CardListingFilter/FilterTypes';
import { StickyBarContainer, Summary } from './StickyBar.style';
import { FreeSamples } from './FreeSamples';

interface StickyBarProps {
  filterMenuList?: any[];
  clearFilters: () => void;
  updateFilter: (filterKey: FilterKey, filterValue?: FilterValue) => void;
  openDrawer: (filterKey: string) => void;
  searchTotal: number;
  searchFilters: CardListingSearchFilters;
  setScrollActive: (active: boolean) => void;
  scrollActive: boolean;
  scrollToTop: () => void;
}

export const StickyBar: React.FC<StickyBarProps> = ({
  filterMenuList,
  clearFilters,
  updateFilter,
  openDrawer,
  searchTotal,
  searchFilters,
  setScrollActive,
  scrollActive,
  scrollToTop,
}) => {
  const dispatch = useDispatch();
  const { is_guest: isGuest } = useSelector(getUserContext);

  useEffect(() => {
    if (isGuest !== undefined && !isGuest) {
      dispatch(fetchProjects());
      dispatch(fetchFavoriteCardSuites());
    }
  }, [dispatch, isGuest]);

  const [isStuck, setStuck] = useState(false);

  return (
    <Sticky
      innerZ="10"
      onStateChange={(status) => {
        setStuck(status.status === Sticky.STATUS_FIXED);
        setScrollActive(!scrollActive);
      }}
    >
      <StickyBarContainer isStuck={isStuck} isMakePhotoPreviewMoreProminent>
        <FilterMobileMenuV2
          filterMenuList={filterMenuList}
          clearFilters={clearFilters}
          updateFilter={updateFilter}
          hidePills={isStuck}
          openDrawer={openDrawer}
          searchFilters={searchFilters}
        />
        <Summary isMakePhotoPreviewMoreProminent>
          <div data-testid="plp-search-total">
            {searchTotal === 1 ? '1 result' : `${searchTotal} results`}
          </div>

          <FreeSamples scrollToTop={scrollToTop} />
        </Summary>
      </StickyBarContainer>
    </Sticky>
  );
};
